import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterNoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_none"}/>
}
